import { MAX_MOBILE_ADDRESS_LENGTH } from 'pages/PageProfile/components/logic/WalletAddressForm/constants/max-mobile-address-length.const';

export const shortenWalletAddress = (walletAddress: string): string => {
  if (walletAddress.length > MAX_MOBILE_ADDRESS_LENGTH) {
    return `${walletAddress.slice(0, MAX_MOBILE_ADDRESS_LENGTH / 2)}.....${walletAddress.slice(walletAddress.length - MAX_MOBILE_ADDRESS_LENGTH / 2)}`;
  }
  return walletAddress;
};
